import { OneWayFeeItemPriceModel } from '../../../api/pricing/pricing.types';
import { Action } from 'redux';

export const EDIT_ONE_WAY_FEE_ITEM_PRICE = 'EDIT_ONE_WAY_FEE_ITEM_PRICE';
export const GET_ONE_WAY_FEE_ITEM_PRICE = 'GET_ONE_WAY_FEE_ITEM_PRICE';

export interface OneWayFeesItemPriceState {
  itemPrice: OneWayFeeItemPriceModel | null;
  lastFetch: number | null;
}

export interface GetOneWayFeesItemPriceAction extends Action {
  type: typeof GET_ONE_WAY_FEE_ITEM_PRICE;
  payload: {
    itemPrice: OneWayFeeItemPriceModel;
  };
}

export interface EditOneWayFeesItemPriceAction extends Action {
  type: typeof EDIT_ONE_WAY_FEE_ITEM_PRICE;
  payload: {
    itemPrice: OneWayFeeItemPriceModel;
  };
}

export type OneWayFeesItemPriceActionTypes = GetOneWayFeesItemPriceAction | EditOneWayFeesItemPriceAction;